import React, { useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../api/client";
import styles from "./NewClientConsultingPage.module.scss";
import { InlineWidget } from "react-calendly";

const NewClientConsultingPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [ssnLast4, setSsnLast4] = useState("");
  const [showCalendly, setShowCalendly] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      // 检查是否为新客户
      const checkRes = await api.post("/checkNewClient", {
        fullName,
        ssn_last4: ssnLast4,
      });

      if (!checkRes.data.isNewClient) {
        setErrorMessage(t("appointment.notNewClient"));
        return;
      }

      // 是新客户，直接显示 Calendly
      setShowCalendly(true);
    } catch (err) {
      console.error(err);
      setErrorMessage(t("appointment.submitNewClientFail"));
    }
  };

  const handleBack = () => {
    navigate("/appointment");
  };

  const handleSsnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      setSsnLast4(value.slice(0, 4));
    }
  };

  return (
    <div className={styles.reviewPage}>
      <div className={styles.reviewContainer}>
        {!showCalendly ? (
          <>
            <h1>{t("appointment.newClientConsulting")}</h1>
            <form onSubmit={handleSubmit} className={styles.reviewForm}>
              <div className={styles.infoHint}>
                <div className={styles.infoIcon}>ℹ️</div>
                <div className={styles.infoContent}>
                  <Trans i18nKey="appointment.newClientOnly" />
                </div>
              </div>
              <hr className={styles.divider} />

              <div className={styles.formLabel}>
                <strong>
                  <label>{t("appointment.fullName")}</label>
                </strong>
                <input
                  type="text"
                  className={styles.inputField}
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
              </div>

              <div className={styles.formLabel}>
                <strong>
                  <label>{t("appointment.email")}</label>
                </strong>
                <input
                  type="email"
                  className={styles.inputField}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className={styles.formLabel}>
                <strong>
                  <label>{t("appointment.ssnLast4")}</label>
                </strong>
                <input
                  type="text"
                  inputMode="numeric"
                  className={styles.inputField}
                  value={ssnLast4}
                  onChange={handleSsnChange}
                  maxLength={4}
                  pattern="\d{4}"
                  placeholder="1234"
                  required
                />
              </div>

              {errorMessage && (
                <p className={styles.errorMessage}>
                  <Trans
                    i18nKey={errorMessage}
                    components={{
                      a: <a href="mailto:info@unlimitedadvisory.com" />,
                    }}
                  />
                </p>
              )}
              <div className={styles.buttons}>
                <button type="button" onClick={handleBack}>
                  {t("general.back")}
                </button>
                <button type="submit">{t("general.submit")}</button>
              </div>
            </form>
          </>
        ) : (
          <>
            <h1>{t("appointment.selectTimeConsulting")}</h1>
            {/* <p className="referral-text">
              {t("appointment.yourName")}
              {": "}
              <strong>{fullName}</strong>
            </p>
            <p className="referral-text">
              {t("appointment.yourEmail")}
              {": "}
              <strong>{email}</strong>
            </p>
            <p className="referral-text">
              {t("appointment.yourSSN")}
              {": "}
              <strong style={{ color: "red" }}>
                {"*".repeat(5) + ssnLast4}
              </strong>
            </p> */}
            <hr className={styles.divider} />
            <div style={{ marginTop: "10px" }}>
              <InlineWidget
                url="https://calendly.com/ruifan-wu/new-client-initial-consulting"
                styles={{ height: "800px" }}
                prefill={{
                  name: fullName,
                  email: email,
                  customAnswers: {
                    a1: ssnLast4,
                  },
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NewClientConsultingPage;
